import { knowledgeBaseDraftKey } from '../../lib/draftStorage';
import type { PlannedPostRead } from '../../types/api';

/**
 * Where a planned-post draft is autosaved.
 *
 * Only a create form is mirrored to storage, under the same key shape as the
 * knowledge-base forms; an edit already has a copy on the server, so it returns
 * null and `useDraft` sits the form out.
 *
 * It lives in its own module because both the form and the screen that saves it
 * need the key — the form to write it, the screen to clear it once the record
 * is on file.
 */
export function plannedPostDraftKey(
  businessId: string,
  item: PlannedPostRead | null,
): string | null {
  return item === null ? knowledgeBaseDraftKey('planned-post', businessId, null) : null;
}
